import SettingsView from "../components/entityViews/settings/SettingsView";

export const SettingsPage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="settings-page">
      <div className="flex-1 min-h-0">
        <SettingsView />
      </div>
    </div>
  );
};

export default SettingsPage;
